import { EQActionType, EQStateType } from "./index";

export type ReturnEQFeatureFlags = {
	autoCallEnabled?: boolean;
	callByTicketNumberEnabled?: boolean;
	callAnotherEnabled?: boolean;
	scheduleEnabled?: boolean;
	transferEnabled?: boolean;
};

const defaultFlags: Required<ReturnEQFeatureFlags> = {
	autoCallEnabled: true,
	callByTicketNumberEnabled: true,
	callAnotherEnabled: true,
	scheduleEnabled: true,
	transferEnabled: true
};

const callByTicketSubActionNames = new Set(["return-invite-ticket"]);

export const resolveReturnFeatureFlags = (flags?: ReturnEQFeatureFlags): Required<ReturnEQFeatureFlags> => ({
	autoCallEnabled: flags?.autoCallEnabled ?? defaultFlags.autoCallEnabled,
	callByTicketNumberEnabled: flags?.callByTicketNumberEnabled ?? defaultFlags.callByTicketNumberEnabled,
	callAnotherEnabled: flags?.callAnotherEnabled ?? defaultFlags.callAnotherEnabled,
	scheduleEnabled: flags?.scheduleEnabled ?? defaultFlags.scheduleEnabled,
	transferEnabled: flags?.transferEnabled ?? defaultFlags.transferEnabled
});

const filterAction = (
	action: EQActionType,
	resolved: Required<ReturnEQFeatureFlags>
): EQActionType | null => {
	if (!resolved.scheduleEnabled && action.name === "schedule") {
		return null;
	}
	if (!resolved.transferEnabled && action.name === "return-redirect") {
		return null;
	}
	if (!resolved.callAnotherEnabled && action.name === "return-invite-another") {
		return null;
	}

	if (!resolved.callByTicketNumberEnabled && action.subAction?.length) {
		const subAction = action.subAction.filter((item) => !callByTicketSubActionNames.has(item.name));
		if (subAction.length === 0) {
			return null;
		}
		if (subAction.length !== action.subAction.length) {
			return { ...action, subAction };
		}
	}

	return action;
};

/** Один пункт в подменю — выполняем его по клику на основную кнопку, без выпадающего списка. */
const flattenSingleSubAction = (action: EQActionType): EQActionType => {
	if (action.subAction?.length !== 1) {
		return action;
	}
	const [only] = action.subAction;
	return {
		...action,
		name: only.name,
		title: action.title ?? only.title,
		icon: action.icon ?? only.icon,
		subAction: undefined
	};
};

/** Применяет флаги из админки к состоянию виджета re:turn. */
export const applyReturnFeatureFlags = (state: EQStateType, flags?: ReturnEQFeatureFlags): EQStateType => {
	const resolved = resolveReturnFeatureFlags(flags);
	let nextState: EQStateType = { ...state };

	if (!resolved.autoCallEnabled) {
		nextState = { ...nextState, hideAutoCall: true };
	}

	const actions = (nextState.actions || [])
		.map((action) => filterAction(action, resolved))
		.filter((action): action is EQActionType => action !== null)
		.map(flattenSingleSubAction);

	return { ...nextState, actions };
};
